export interface IImitateSession {
  userId?: number;
  userName?: string;
  orgId?: number;
  orgName?: string;
  level: 'PRIMARY' | 'OPERATOR' | 'SERVICE_PROVIDER' | 'CUSTOMER' | string;
  allowWrite: boolean;
  subscriptionLevel?: string;
}

const STORAGE_KEY = 'hankix_imitate_session';

export const getImitateSession = (): IImitateSession | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as IImitateSession;
  } catch (e) {
    console.error('Failed to parse imitate session', e);
    return null;
  }
};

export const saveImitateSession = (session: IImitateSession): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch (e) {
    console.error('Failed to save imitate session', e);
  }
};

export const clearImitateSession = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Failed to clear imitate session', e);
  }
};

export const setImitateAllowWrite = (allowWrite: boolean): IImitateSession | null => {
  const current = getImitateSession();
  if (!current) return null;
  const updated: IImitateSession = { ...current, allowWrite };
  saveImitateSession(updated);
  return updated;
};
